import React, { Component, useState, useRef, useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import '../99_untils/i18n';

import {
  Button, Container, Row, Col,
  // Card, CardBody, CardTitle, CardSubtitle, CardText 
} from 'reactstrap';

import apiURLs from '../99_untils/apiURLs';

import './HomeBanner.css';

export default function HomeBanner() {
  const isMountedRef = useRef();
  const { i18n } = useTranslation();
  const [curLang, setCurLang] = useState(i18n.language);

  const [loadDataBool, setLoadDataBool] = useState(false);
  const [noticeActivityData, setNoticeActivityData] = useState(null);


  // Update current language when i18n changes
  useEffect(() => {
    setCurLang(i18n.language);
  }, [i18n.language]);

  useEffect(() => {

    isMountedRef.current = true;

    const fetchData = async () => {
      try {
        const response = await fetch(apiURLs.getHomeBannerDataURL, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            ...(window.authTokenData ? { 'Authorization': `Bearer ${window.authTokenData}` } : {})
          }
        });
        // const response = await fetch('https://api.once.dev2.dash-hk.com/instagram/posts');
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();

        if (isMountedRef.current) {
          if (result.banner.en !== "" && result.banner.hk !== "") {
            // setNoticeActivityData(result.banner);
            setLoadDataBool(true);
          }
        }

        // console.log('HomeBanner fetchData result:', result);
        // console.log('HomeBanner curLang:', curLang);

        if (isMountedRef.current) { // Only update state if the component is still mounted
          if (result.banner.en !== "" && result.banner.hk !== "") {
            setNoticeActivityData(result.banner);
          }
        }
      } catch (error) {
        setLoadDataBool(false);
        //   setError(error);
        // console.log('fetchData error')
      } finally {
        // console.log('fetchData loading finished ')
        //   setLoading(false);
      }
    };

    fetchData();

    // setNoticeActivityData('Some message about live activity goes here. Stay tuned for updates!');


    return () => {
      isMountedRef.current = false;

      // console.log("HomeBanner unmount")

    };
  }, []);





  // return (
  return noticeActivityData && loadDataBool ? (
    <div className="home-banner-intro-wrap">

      {/* <Container className="home-banner-intro-content-wrap">
        <Row className=''>
          <Col md={{
              offset: 3,
              size: 6
            }}>
            <p className='margin-bot-0'>{curLang === 'en-HK' ? noticeActivityData.en : noticeActivityData.hk}</p>
            <div className='corner-paper'></div>
          </Col>
        </Row>
      </Container> */}
      <div className='corner-paper'></div>
      <p className='home-banner-intro-content-wrap margin-bot-0'>{curLang === 'en-HK' ? noticeActivityData.en : noticeActivityData.hk}</p>
    </div>
  ) : null;
  // }
}

